import { useApiClient } from '@/composables/useApiClient'
import { RegionPaymentCurrency } from '~/view-models/currency'

export const state = () => ({
  currencies: [],
  currencyMapByCode: {},
  currencyOfCreditCard: {},
})

export const getters = {
  allCurrency: state => state.currencies,
  currencyMapByCode: state => state.currencyMapByCode,
  currencyOfCreditCard: state => state.currencyOfCreditCard,
}

export const actions = {
  async getCurrency({ dispatch, commit }) {
    const res = await useApiClient().$get(`/pub/currency`)
    if (res.code === 0) {
      commit('SET_CURRENCY', res.data)
      dispatch('getCurrencyMapByCode')
    }
  },
  getCurrencyMapByCode({ state, commit }) {
    const currencyMap = {}
    state.currencies.forEach(currency => {
      currencyMap[currency.code] = currency
    })
    commit('SET_CURRENCY_BY_CODE', currencyMap)
  },
  getCurrenyOfCreditCard({ state, commit }) {
    const currencyMap = state.currencyMapByCode
    // doc: https://github.com/funnow-docs/funnow-api-doc/blob/4fcfb898f0b580f7c4f421b945de27fea2c4d4e9/docs/payment/get.md#%E4%BB%98%E6%AC%BE%E9%A0%81
    commit('SET_CURRENCY_OF_CREDIT_CARD', {
      [RegionPaymentCurrency.Taiwan]: currencyMap.TWD,
      [RegionPaymentCurrency.HongKongBrainTree]: currencyMap.HKD,
      [RegionPaymentCurrency.MalaysiaTapPay]: currencyMap.MYR,
      [RegionPaymentCurrency.HongKong]: currencyMap.HKD,
      [RegionPaymentCurrency.Japan]: currencyMap.JPY,
      [RegionPaymentCurrency.Thailand]: currencyMap.THB,
      [RegionPaymentCurrency.MalaysiaStripe]: currencyMap.MYR,
    })
  },
}

export const mutations = {
  SET_CURRENCY(state, currencies) {
    state.currencies = currencies
  },
  SET_CURRENCY_BY_CODE(state, currencyMap) {
    state.currencyMapByCode = Object.assign({}, currencyMap || {})
  },
  SET_CURRENCY_OF_CREDIT_CARD(state, currencyOfCreditCard) {
    state.currencyOfCreditCard = Object.assign({}, currencyOfCreditCard || {})
  },
}
